import { Spinner } from './Spinner';

type StaffFullRoutePreloaderProps = {
  label: string;
  'data-testid'?: string;
};

/** Полноэкранный прелоадер сессии/соглашений (`ProtectedRoute`); ленивые экраны показывают `StaffRouteContentSkeleton` внутри `main`. */
export function StaffFullRoutePreloader({ label, 'data-testid': testId }: StaffFullRoutePreloaderProps) {
  return (
    <div className="staff-route-loading" role="status" aria-live="polite" data-testid={testId}>
      <Spinner label={label} />
    </div>
  );
}
